export function phoneValidate(phone: string) {
  const onlyDigits = phone.replace(/\D/g, '')

  if (onlyDigits.length !== 10 && onlyDigits.length !== 11) return false

  if (/^(\d)\1{9,}$/.test(onlyDigits)) return false

  // Valida DDD
  const validDDDs = new Set([
    '11','12','13','14','15','16','17','18','19',
    '21','22','24','27','28',
    '31','32','33','34','35','37','38',
    '41','42','43','44','45','46',
    '51','53','54','55',
    '61','62','64','63','65','66','67',
    '68','69','71','73','74','75','77','79',
    '81','82','83','84','85','86','87','88','89',
    '91','92','93','94','95','96','97','98','99'
  ])
  const ddd = onlyDigits.substring(0, 2)
  if (!validDDDs.has(ddd)) return false

  // Se for celular, precisa começar com 9 após o DDD
  if (onlyDigits.length === 11 && onlyDigits[2] !== '9') return false

  return true
}
